import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { captureUtm } from './services/analytics'
import { initErrorMonitoring } from './services/errorMonitoring'
// Self-hosted variable font (bundled + hashed by Vite; includes latin-ext for č ć ž š đ).
import '@fontsource-variable/plus-jakarta-sans'
import './i18n'
import './index.css'

// Crash reporting first, so init-time errors are captured too.
initErrorMonitoring()
// First-touch campaign capture from the landing URL, before any lookup runs.
captureUtm()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
